import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'; 
import Pictures from '../../screen/pictures';

const AppRoute = () => {
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route path="/:slotId" exact component={Pictures}></Route> 
                </Switch>
            </BrowserRouter>
        </>
    );
}

export default AppRoute;